import {useEffect} from "react";
import formatDate from "@DateTime/functions/formatDate";
import {setDate} from "@Form/reducers/formSlice";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {dateFormat} from "@Form/features/dates/constants/dateFormat";

export default function usePrefillDateLeadTimeTest(date: string | null) {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!date) {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            dispatch(setDate(formatDate(tomorrow, dateFormat)));
        }
    }, []);
}